import React, { useState } from "react";
import AppSidebar from "./AppSidebar";
import AppHeader from "./AppHeader";
import BottomTabBar from "./BottomTabBar";

const Layout = ({ children }: { children: React.ReactNode }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      <AppSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <AppHeader onMenuClick={() => setSidebarOpen((v) => !v)} />

      {/* `pb-16` clears the bottom tab bar, which is fixed and would otherwise
          sit on top of the last row of whatever list is open. */}
      <main className="md:ml-64 pt-16 pb-16 md:pb-0 min-h-screen">
        <div className="p-4 md:p-6 lg:p-8">{children}</div>
      </main>

      <BottomTabBar onMore={() => setSidebarOpen(true)} />
    </div>
  );
};

export default Layout;
